import { InfoTextDesign } from "@/components/atoms/InfoTextDesign";
import { derivePossessiveForm } from "@/utils";

export const InfoText = ({ lastActivity, mapName }) => {
	const todayDay = new Date().getDate();
	const todayMonth = new Date().getMonth();
	const todayYear = new Date().getFullYear();

	const adjustedMonth = todayDay >= 5 ? todayMonth : todayMonth - 1;
	const adjustedYear = adjustedMonth === 0 ? todayYear - 1 : todayYear;

	const formattedDate = new Date(
		adjustedYear,
		adjustedMonth,
		todayDay
	).toLocaleString("en-US", {
		month: "short",
		year: "numeric",
	});

	if (lastActivity) {
		return (
			<div
				id="community-modal-trigger-info-text"
				className="flex flex-col md:flex-row gap-1 first-line:md:gap-2 w-full md:justify-between">
				<InfoTextDesign>
					By {derivePossessiveForm(mapName)} gluten-free community
				</InfoTextDesign>
				<InfoTextDesign light>Updated {formattedDate}</InfoTextDesign>
			</div>
		);
	}

	if (mapName) {
		return <InfoTextDesign>Featured in the {mapName} on Atly</InfoTextDesign>;
	}

	return null;
};
